import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import PropTypes from 'prop-types';
import vapi from '../../../javascript/frontend/api/vapi';
import vahoy from '../../../javascript/vahoy';

class EmailContactsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: props.showPopup,
      hasCopied: false,
      emails: ['', '', '', ''],
      errors: {},
      emailSent: false,
    };
    this.close = this.close.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
  }

  handleCopy = () => {
    navigator.clipboard.writeText(this.props.sourceRequestShareWithSourcesUrl);
    this.setState({ hasCopied: true });
  };

  static getDerivedStateFromProps(props, state) {
    if (props.showPopup !== state.showPopup) {
      if (props.showPopup) {
        return {
          showPopup: props.showPopup,
          emails: ['', '', '', ''],
          errors: {},
          emailSent: false,
        };
      }
      return { showPopup: props.showPopup };
    }
    return {};
  }

  handleChange = (index, event) => {
    const { value } = event.target;
    this.setState((prevState) => {
      const newEmails = [...prevState.emails];
      newEmails[index] = value;
      const fieldKey = `email${index + 1}`;
      const newErrors = { ...prevState.errors };

      if (newErrors[fieldKey]) {
        delete newErrors[fieldKey];
      }

      return { emails: newEmails, errors: newErrors };
    });
  };

  sendEmail = () => {
    const {
      sourceRequestId,
    } = this.props;

    const { emails } = this.state;

    // Send all emails (including blanks) so server can validate them properly
    vapi.emailContacts(sourceRequestId, emails)
      .then(() => {
        this.setState({
          emailSent: true,
          emails: ['', '', '', ''],
          errors: {},
        });
        setTimeout(() => {
          this.setState({ emailSent: false });
        }, 3000);
      })
      .catch((error) => {
        const serverErrors = error && error.response && error.response.data && error.response.data.errors;
        if (serverErrors) {
          this.setState((prev) => ({
            errors: { ...prev.errors, ...serverErrors },
          }));
        }
        return error;
      });

    vahoy.track('EmailContactsModal#sendEmail');
  };

  close = () => {
    const { closeModal } = this.props;

    closeModal();
  };

  render() {
    const {
      showPopup,
      hasCopied,
      errors,
      emailSent,
    } = this.state;

    const { sourceRequestShareWithSourcesUrl } = this.props;
    const { emails } = this.state;

    const closeBtn = (
      <button type="button" className="btn-close" aria-label="Close" onClick={this.close} />
    );

    /* eslint-disable react/no-danger */
    return (
      <Modal className="modal-lg" isOpen={showPopup} toggle={this.close} backdrop="static">
        <ModalHeader toggle={this.close} close={closeBtn}>
          <div className="row">
            <div className="col-12">
              <h4 className="fw-bold">Invite Contacts</h4>
              Invite Experts from your network to join Qwoted and pitch this opportunity.
            </div>
          </div>
        </ModalHeader>

        <ModalBody>
          <div className="row">
            <h4 className="fw-bold">Email Addresses</h4>
            <div className="col-12 mb-4">
              <div className="mb-3">
                <input
                  id="email1"
                  className="form-control placeholder-muted"
                  type="email"
                  placeholder="@ Work or Business Email"
                  value={emails[0]}
                  onChange={(e) => this.handleChange(0, e)}
                  required
                />
                {errors.email1 && (
                  <div className="text-danger small">{errors.email1}</div>
                )}
              </div>
              <div className="mb-3">
                <input
                  id="email2"
                  className="form-control placeholder-muted"
                  type="email"
                  placeholder="@ Work or Business Email"
                  value={emails[1]}
                  onChange={(e) => this.handleChange(1, e)}
                  required
                />
                {errors.email2 && (
                  <div className="text-danger small">{errors.email2}</div>
                )}
              </div>
              <div className="mb-3">
                <input
                  id="email3"
                  className="form-control placeholder-muted"
                  type="email"
                  placeholder="@ Work or Business Email"
                  value={emails[2]}
                  onChange={(e) => this.handleChange(2, e)}
                  required
                />
                {errors.email3 && (
                  <div className="text-danger small">{errors.email3}</div>
                )}
              </div>
              <div className="mb-3">
                <input
                  id="email4"
                  className="form-control placeholder-muted"
                  type="email"
                  placeholder="@ Work or Business Email"
                  value={emails[3]}
                  onChange={(e) => this.handleChange(3, e)}
                  required
                />
                {errors.email4 && (
                  <div className="text-danger small">{errors.email4}</div>
                )}
              </div>
              {!emailSent && (
                <Button
                  color="primary"
                  block
                  onClick={this.sendEmail}
                  disabled={emails.every((e) => !e.trim())}
                >
                  <i className="fa-solid fa-envelope" />&nbsp;Send Invite
                </Button>
              )}
              {emailSent && (
                <div className="btn text-matcha-80 border-color-matcha-30 background-color-matcha-10 w-100" tabIndex={-1} style={{ pointerEvents: 'none' }}>
                  <i className="fa-regular fa-check" aria-hidden="true" />&nbsp;Invitation Sent
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <h4 className="fw-bold">Or share a sign-up link in your favorite messenger.</h4>
            <div className="input-group mb-2">
              <input
                className="form-control"
                type="text"
                value={sourceRequestShareWithSourcesUrl}
                readOnly
              />
              <div
                className={`input-group-append${hasCopied ? ' d-none' : ''}`}
                role="button"
                tabIndex={0}
                onClick={this.handleCopy}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.handleCopy();
                  }
                }}
              >
                <div
                  className="input-group-text text-periwinkle-50 border-color-periwinkle-20 background-color-periwinkle-10"
                  style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                >
                  <i className="fa-regular fa-clipboard" aria-hidden="true" />&nbsp;Copy
                </div>
              </div>
              <div className={`input-group-append${hasCopied ? '' : ' d-none'}`}>
                <div
                  className="input-group-text text-matcha-80 border-color-matcha-30 background-color-matcha-10"
                  style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                >
                  <i className="fa-regular fa-check" aria-hidden="true" />&nbsp;Copied
                </div>
              </div>
            </div>
          </div>
        </ModalBody>

      </Modal>
    );
    /* eslint-enable react/no-danger */
  }
}

EmailContactsModal.propTypes = {
  sourceRequestId: PropTypes.number.isRequired,
  sourceRequestShareWithSourcesUrl: PropTypes.string.isRequired,
  showPopup: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
};

EmailContactsModal.defaultProps = {
  showPopup: undefined,
};

export default EmailContactsModal;
